// src/components/ChequeTable.js
// import { Add as AddIcon } from '@mui/icons-material';
import React, { useState, useEffect, useCallback } from 'react';

import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import { alpha, useTheme } from '@mui/material/styles';
import {
  Box,
  Alert,
  Table,
  Button,
  Dialog,
  Container,
  TableBody,
  TableCell,
  DialogTitle,
  DialogContent,
  TableContainer,
  CircularProgress,
} from '@mui/material';

import { paths } from 'src/routes/paths';

import { useBoolean } from 'src/hooks/use-boolean';

import { isAfter, isBetween } from 'src/utils/format-time';

import { deleteCheck, getChecksWithDetails } from 'src/services/finance/finance-service-calls';

import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import EmptyContent from 'src/components/empty-content/index';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
  useTable,
  emptyRows,
  getComparator,
  TableEmptyRows,
  TableHeadCustom,
  TableSelectedAction,
  TablePaginationCustom,
} from 'src/components/table';

// import { getBanks, getChecks, getAccounts } from 'src/services/finance/finance-service-calls';

import CheckNewEditForm from './Check-request-edit-form';
import CheckCreateForm from './Check-request-create-form';
import CheckRequestAnalytic from './Check-request-analytic';
import CheckRequestTableRow from './check-request-table-row';
import CheckReceivedForm from './Check-request-received-form';
import ChecksRequestTableToolbar from './check-request-table-toolbar';
import ChecksRequestTableFiltersResult from './Check-request-table-filters-result';

const TABLE_HEAD = [
  { id: 'checkNumber', label: 'Número de cheque' },
  { id: 'bankAccount', label: 'Cuenta bancaria' },
  { id: 'amount', label: 'Monto' },
  { id: 'description', label: 'Descripción' },
  { id: 'creationDate', label: 'Fecha de creación' },
  { id: 'checkDate', label: 'Fecha de ejecución' },
  { id: 'receivedBy', label: 'Recibido' },
  { id: 'createdBy', label: 'Creado' },
  { id: '' },
];

const defaultFilters = {
  name: '',
  admissionType: [],
  status: [],
  startDate: null,
  endDate: null,
};

export default function CheckListView() {
  // const { enqueueSnackbar } = useSnackbar();

  const theme = useTheme();

  const settings = useSettingsContext();

  const table = useTable({ defaultOrderBy: 'createDate' });

  const [requestToEdit, setRequestToEdit] = useState(null);

  const approveRequest = useBoolean();
  const CancelRequest = useBoolean();
  const editRequest = useBoolean();
  const createCheck = useBoolean();

  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [filters, setFilters] = useState(defaultFilters);

  const dateError = isAfter(filters.startDate, filters.endDate);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await getChecksWithDetails();
        if (response.status === 200) {
          setTableData(response.data);
        } else {
          setError('Error al cargar los cheques');
        }
      } catch (err) {
        console.error('Error fetching checks:', err);
        setError('Error de conexión al cargar los cheques');
        setTableData([]);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const dataFiltered = applyFilter({
    inputData: tableData,
    comparator: getComparator(table.order, table.orderBy),
    filters,
    dateError,
  });

  const denseHeight = table.dense ? 56 : 56 + 20;

  const canReset =
    !!filters.name ||
    !!filters.admissionType.length ||
    !!filters.status.length ||
    (!!filters.startDate && !!filters.endDate);

  // calculate the receivedDate to present
  const CalculateDate = (item) => {
    const { receivedDate, isDeleted } = item;
    if (
      (new Date(receivedDate) > new Date() ||
        receivedDate === null ||
        receivedDate === undefined) &&
      isDeleted !== 1
    ) {
      return false;
    }
    if (isDeleted !== 1) {
      return true;
    }
    return null;
  };

  // For overDate and underDate
  const getReceiveDate = (booleanIdentifier) =>
    tableData.filter((item) => CalculateDate(item) === booleanIdentifier).length;

  // for canceled checks
  const getCanceledCheck = (deleted) =>
    tableData.filter((item) => item.isDeleted === deleted).length;

  const getPercentByStatus = (status) => (getReceiveDate(status) / tableData.length) * 100;
  const getPercentCanceled = () => (getCanceledCheck(1) / tableData.length) * 100;

  const TABS = [
    { value: 'all', label: 'Todos', color: 'default', count: tableData.length },
    {
      value: 'Pending',
      label: 'Pendientes de entrega',
      color: 'warning',
      count: getReceiveDate(false),
    },
    {
      value: 'Canceled',
      label: 'Cancelados',
      color: 'error',
      count: getCanceledCheck(1),
    },
    {
      value: 'Received',
      label: 'Entregados',
      color: 'success',
      count: getReceiveDate(true),
    },
  ];

  const handleFilters = useCallback(
    (name, value) => {
      table.onResetPage();
      setFilters((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    },
    [table]
  );

  const handleResetFilters = useCallback(() => {
    setFilters(defaultFilters);
  }, []);

  const handleDeleteRow = useCallback(
    async (data) => {
      // TODO: VERIFICAR CON RONEL
      console.log(data); // Be aware that this can be a object or array of abjects

      /* if (response.status === 200) {
          enqueueSnackbar('Eliminado satisfactoriamente');
          const deleteRow = tableData.filter((row) => row.productId !== id);
          setTableData(deleteRow);
          table.onUpdatePageDeleteRow(dataInPage.length);
          refreshData();
        } else {
          enqueueSnackbar('Error al eliminar la solicitud', { variant: 'error' });
        } */
    },
    //   [dataInPage.length, enqueueSnackbar, refreshData, table, tableData]
    []
  );

  const handleCancel = useCallback(async (data) => {
    try {
      await deleteCheck(data.checkId);
      setLoading(true);
      setError(null);

      const finalResponse = await getChecksWithDetails();
      if (finalResponse.status === 200) {
        setTableData(finalResponse.data);
      } else {
        setError('Error al cargar los cheques');
      }
    } catch (err) {
      console.error('Error fetching checks:', err);
      setError('Error de conexión al cargar los cheques');
      setTableData([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const handleFilterStatus = useCallback(
    (event, newValue) => {
      handleFilters('status', newValue === 'all' ? [] : [newValue]);
    },
    [handleFilters]
  );

  const refreshData = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await getChecksWithDetails();

      if (response.status === 200) {
        setTableData(response.data);
      } else {
        setError('Error al cargar los cheques');
      }
    } catch (err) {
      console.error('Error refreshing checks:', err);
      setError('Error de conexión al cargar los cheques');
    } finally {
      setLoading(false);
    }
  }, []);

  const handleDeletedSelected = () => {
    setRequestToEdit(
      dataFiltered
        .filter((item) => table.selected.includes(item.checkId))
        .filter((el) => el.isDeleted === 0)
    );
    CancelRequest.onTrue();
  }; // this give a array of objects

  const renderTableEmptyState = () => {
    if (loading) {
      return (
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
          <CircularProgress />
        </Box>
      );
    }

    if (error) {
      return (
        <Alert severity="error" sx={{ my: 2 }}>
          {error}
        </Alert>
      );
    }

    if (!tableData.length) {
      return (
        <EmptyContent
          filled
          title="Sin Cheques"
          sx={{
            py: 10,
          }}
        />
      );
    }

    return <TableCell colSpan={12} sx={{ p: 0 }} />;
  };

  return (
    <>
      <Container maxWidth={settings.themeStretch ? false : 'lg'}>
        <CustomBreadcrumbs
          heading="Cheques"
          links={[
            {
              name: 'Medicore',
              href: paths.medicore.root,
            },
            {
              name: 'Contabilidad',
            },
          ]}
          sx={{ mb: { xs: 6, md: 4 } }}
        />
        <Card
          sx={{
            mb: { xs: 3, md: 5 },
          }}
        >
          <Scrollbar>
            <Stack
              direction="row"
              divider={<Divider orientation="vertical" flexItem sx={{ borderStyle: 'dashed' }} />}
              sx={{ py: 2 }}
            >
              <CheckRequestAnalytic
                title="Total"
                total={tableData.length}
                percent={100}
                icon="solar:bill-list-bold-duotone"
                color={theme.palette.info.main}
              />

              <CheckRequestAnalytic
                title="Entregados"
                total={getReceiveDate(true)}
                percent={getPercentByStatus(true)}
                icon="solar:file-check-bold-duotone"
                color={theme.palette.success.main}
              />

              <CheckRequestAnalytic
                title="Pendiente"
                total={getReceiveDate(false)}
                percent={getPercentByStatus(false)}
                icon="solar:sort-by-time-bold-duotone"
                color={theme.palette.warning.main}
              />

              <CheckRequestAnalytic
                title="Cancelados"
                total={getCanceledCheck(1)}
                percent={getPercentCanceled()}
                icon="solar:bell-bing-bold-duotone"
                color={theme.palette.error.main}
              />
            </Stack>
          </Scrollbar>
        </Card>
        <Button
          variant="contained"
          color="info"
          onClick={() => {
            createCheck.onTrue();
          }}
          sx={{ display: 'flex', justifySelf: 'end', mb: 2, mr: 2, width: '20%' }}
        >
          <Iconify icon="ic:round-plus" sx={{ mr: 1 }} /> Crear cheque
        </Button>

        <Button
          variant="outlined"
          color="primary"
          onClick={refreshData}
          disabled={loading}
          sx={{ display: 'flex', justifySelf: 'end', mb: 2, mr: 2, width: '15%' }}
        >
          <Iconify icon="solar:refresh-bold" sx={{ mr: 1 }} />
          {loading ? 'Cargando...' : 'Actualizar'}
        </Button>

        <Card>
          <Tabs
            value={filters.status[0] || 'all'}
            onChange={handleFilterStatus}
            sx={{
              px: 2.5,
              boxShadow: `inset 0 -2px 0 0 ${alpha(theme.palette.grey[500], 0.08)}`,
            }}
          >
            {TABS.map((tab) => (
              <Tab
                key={tab.value.toString()}
                value={tab.value.toString()}
                label={tab.label}
                iconPosition="end"
                icon={
                  <Label
                    variant={
                      ((tab.value === 'all' || tab.value === filters.status) && 'filled') || 'soft'
                    }
                    color={tab.color}
                  >
                    {tab.count}
                  </Label>
                }
              />
            ))}
          </Tabs>

          <ChecksRequestTableToolbar
            filters={filters}
            onFilters={handleFilters}
            //
            dateError={dateError}
          />

          {canReset && (
            <ChecksRequestTableFiltersResult
              filters={filters}
              onFilters={handleFilters}
              //
              onResetFilters={handleResetFilters}
              //
              results={dataFiltered.length}
              sx={{ p: 2.5, pt: 0 }}
            />
          )}

          <TableContainer sx={{ position: 'relative', overflow: 'unset' }}>
            <TableSelectedAction
              dense={table.dense}
              numSelected={table.selected.length}
              rowCount={dataFiltered.length}
              onSelectAllRows={(checked) => {
                table.onSelectAllRows(checked, dataFiltered);
              }}
              action={
                <Stack direction="row">
                  <Tooltip title="Delete">
                    <IconButton color="primary" onClick={handleDeletedSelected}>
                      <Iconify icon="solar:trash-bin-trash-bold" />
                    </IconButton>
                  </Tooltip>
                </Stack>
              }
            />

            <Scrollbar>
              <Table size={table.dense ? 'small' : 'medium'} sx={{ minWidth: 800 }}>
                <TableHeadCustom
                  order={table.order}
                  orderBy={table.orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={dataFiltered.length}
                  numSelected={table.selected.length}
                  onSort={table.onSort}
                  onSelectAllRows={(checked) =>
                    table.onSelectAllRows(
                      checked,
                      dataFiltered.map((row) => row.checkId)
                    )
                  }
                />

                <TableBody>
                  {dataFiltered
                    .slice(
                      table.page * table.rowsPerPage,
                      table.page * table.rowsPerPage + table.rowsPerPage
                    )
                    .map((row) => (
                      <CheckRequestTableRow
                        key={row.checkId}
                        row={row}
                        selected={table.selected.includes(row.checkId)}
                        onSelectRow={() => table.onSelectRow(row.checkId)}
                        onDeleteRow={() => handleDeleteRow(row.checkId)}
                        approveRequest={approveRequest}
                        CancelRequest={CancelRequest}
                        editRequest={editRequest}
                        setSelected={setRequestToEdit}
                      />
                    ))}

                  <TableEmptyRows
                    height={denseHeight}
                    emptyRows={emptyRows(table.page, table.rowsPerPage, dataFiltered.length)}
                  />

                  <TableCell colSpan={12}>{renderTableEmptyState()}</TableCell>
                </TableBody>
              </Table>
            </Scrollbar>
          </TableContainer>

          <TablePaginationCustom
            count={dataFiltered.length}
            page={table.page}
            rowsPerPage={table.rowsPerPage}
            onPageChange={table.onChangePage}
            onRowsPerPageChange={table.onChangeRowsPerPage}
            //
            dense={table.dense}
            onChangeDense={table.onChangeDense}
          />
        </Card>
      </Container>

      <Dialog
        open={editRequest.value}
        onClose={(event, reason) => editRequest.onCloseNotBackdrop(event, reason)}
        fullWidth
      >
        <DialogTitle>Editar Solicitud</DialogTitle>
        <DialogContent>
          <CheckNewEditForm
            openCloseModal={editRequest}
            currentRequest={requestToEdit}
            refreshData={refreshData}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={approveRequest.value}
        onClose={(event, reason) => approveRequest.onCloseNotBackdrop(event, reason)}
        fullWidth
      >
        <DialogTitle>Solicitud de recibida</DialogTitle>
        <DialogContent>
          <CheckReceivedForm
            openCloseModal={approveRequest}
            currentRequest={requestToEdit}
            refreshData={refreshData}
          />
        </DialogContent>
      </Dialog>

      <Dialog
        open={createCheck.value}
        onClose={(event, reason) => createCheck.onCloseNotBackdrop(event, reason)}
        fullWidth
      >
        <DialogTitle>Crear cheque</DialogTitle>
        <DialogContent>
          <CheckCreateForm
            openCloseModal={createCheck}
            currentRequest={requestToEdit}
            refreshData={refreshData}
          />
        </DialogContent>
      </Dialog>

      <ConfirmDialog
        open={CancelRequest.value}
        onClose={CancelRequest.onFalse}
        title="Cancelar cheque"
        content={<>¿Está seguro que desea cancelar esta solicitud?</>}
        action={
          <Button
            variant="contained"
            color="warning"
            onClick={() => {
              handleCancel(requestToEdit);
              CancelRequest.onFalse();
            }}
            fullWidth
          >
            Cancelar
          </Button>
        }
      />
    </>
  );
}


function applyFilter({ inputData, comparator, filters, dateError }) {
  const { name, status, startDate, endDate } = filters;

  const stabilizedThis = inputData.map((el, index) => [el, index]);

  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });

  inputData = stabilizedThis.map((el) => el[0]);

  if (name) {
    inputData = inputData.filter(
      (check) => {
        const checkNumber = check.checkNumber?.toString().toLowerCase() || '';
        const bankAccountName = check.bankAccount?.name?.toLowerCase() || '';
        
        // Manejar recievedName que puede ser string o objeto
        const receivedName = typeof check.recievedName === 'string' 
          ? check.recievedName.toLowerCase()
          : check.recievedName?.name?.toLowerCase() || '';
        
        const createdBy = check.createdBy?.toLowerCase() || '';
        
        return checkNumber.indexOf(name.toLowerCase()) !== -1 ||
               bankAccountName.indexOf(name.toLowerCase()) !== -1 ||
               receivedName.indexOf(name.toLowerCase()) !== -1 ||
               createdBy.indexOf(name.toLowerCase()) !== -1;
      }
    );
  }
  
  if (status.length > 0) {
    inputData = inputData.filter((row) => {
      if (status[0] === "Canceled") {
        return row.isDeleted === 1
      } if (status[0] === "Pending" && row.isDeleted !== 1) {
        return new Date(row.receivedDate) > new Date();
      } if (status[0] === "Received" && row.isDeleted !== 1){
        return new Date(row.receivedDate) <= new Date()
      }
      return null
    });
  }

  if (!dateError) {
    if (startDate && endDate) {
      inputData = inputData.filter((check) =>
        isBetween(check.receivedDate, startDate, endDate)
      );
    }
  }

  return inputData;
}






/* export default function CheckListView() {
  const [cheques, setCheques] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [newCheque, setNewCheque] = useState({
    checkNumber: '',
    bankAccountId: '',
    amount: 0,
    description: '',
    templateId: '',
    recievedName: '',
    checkDate: new Date().toISOString(),
    createUser: '',
    accountCatalog: '',
    procedimentType: 0,
    otherAffectedAccount: '',
  });
  const [accounts, setAccounts] = useState([]);
  const [catalogs, setCatalogs] = useState([]);
  const [affectedAccounts, setAffectedAccounts] = useState([]);

  useEffect(() => {
    fetchCheques();
    fetchAccounts();
    fetchCatalogs();
  }, []);

  const fetchCheques = async () => {
    const response = await getChecks();
    setCheques(response.data);
  };

  const fetchAccounts = async () => {
    const response = await getBanks();
    setAccounts(response.data);
  };

  const fetchCatalogs = async () => {
    const response = await getAccounts();
    setCatalogs(response.data);
    setAffectedAccounts(response.data);
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewCheque({ ...newCheque, [name]: value });
  };

  const handleSubmit = async () => {
    // Reemplaza con tu servicio para crear un cheque
    await axios.post('/api/cheques', newCheque);
    fetchCheques();
    handleClose();
  };

  return (
    <>
      <Button variant="contained" color="primary" size="small" onClick={handleOpen}>
        Crear Cheque
      </Button>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Número de Cheque</TableCell>
              <TableCell>Cuenta Bancaria</TableCell>
              <TableCell>Monto</TableCell>
              <TableCell>Descripción</TableCell>
              <TableCell>Recibido Por</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cheques.map((cheque) => (
              <TableRow key={cheque.checkNumber}>
                <TableCell>{cheque.checkNumber}</TableCell>
                <TableCell>{cheque.bankAccountId}</TableCell>
                <TableCell>{cheque.amount}</TableCell>
                <TableCell>{cheque.description}</TableCell>
                <TableCell>{cheque.recievedName}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal open={modalOpen} onClose={handleClose}>
        <Box sx={style}>
          <h2>Crear Cheque</h2>
          <TextField
            label="Número de Cheque"
            name="checkNumber"
            value={newCheque.checkNumber}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Cuenta Bancaria</InputLabel>
            <Select name="bankAccountId" value={newCheque.bankAccountId} onChange={handleChange}>
              {accounts.map((account) => (
                <MenuItem key={account.id} value={account.id}>
                  {account.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Monto"
            name="amount"
            type="number"
            value={newCheque.amount}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Descripción"
            name="description"
            value={newCheque.description}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <TextField
            label="Recibido Por"
            name="recievedName"
            value={newCheque.recievedName}
            onChange={handleChange}
            fullWidth
            margin="normal"
          />
          <FormControl fullWidth margin="normal">
            <InputLabel>Catálogo de Cuentas</InputLabel>
            <Select name="accountCatalog" value={newCheque.accountCatalog} onChange={handleChange}>
              {catalogs.map((catalog) => (
                <MenuItem key={catalog.id} value={catalog.id}>
                  {catalog.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <FormControl fullWidth margin="normal">
            <InputLabel>Otra Cuenta Afectada</InputLabel>
            <Select
              name="otherAffectedAccount"
              value={newCheque.otherAffectedAccount}
              onChange={handleChange}
            >
              {affectedAccounts.map((account) => (
                <MenuItem key={account.id} value={account.id}>
                  {account.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Guardar
          </Button>
        </Box>
      </Modal>
    </>
  );
} */
